export class FilterScheduleData {
  public  company_code?: string;
  public  plant?: string;
  public doc_type?: string;
  public doc_cat?: string;
  public poagreement_no?: string;
  public  vendor_code?: string;
  public  status?: string;
  public  document_date?: Date; 
  // public delivery_date?: Date; 
  [key: string]: string | Date | undefined; 
}
export class FilterScheduleDate {
  public delivery_date?: Date; 
}